export default {
    'sales-contracts': 'Contratos de ventas',
    'the-sales-contract': 'es el Contrato de venta?',
    'add-a-sales-contract': 'Agregar contrato de venta',

    'sales-contract': 'Contrato de ventas',
}